import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { Field, TextInput, TextArea, SelectInput } from '../lib/FormControls';
import { INSURANCE_OPTION_OPTIONS, INSURANCE_TYPE_OPTIONS, initialBeneficiary } from '../lib/fieldDefs';

export default function Step4Insurance({ form, setField, setForm, updateBeneficiary }) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-gray-900">Insurance Information</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Field label="Insurance Type" required>
          <SelectInput
            value={form.insurance_type}
            onChange={(e) => setField('insurance_type', e.target.value)}
            options={INSURANCE_TYPE_OPTIONS}
          />
        </Field>
        <Field label="Monthly Premium">
          <TextInput
            value={form.monthly_premium}
            onChange={(e) => setField('monthly_premium', e.target.value)}
          />
        </Field>
        <Field label="Insurance Option" required>
          <SelectInput
            value={form.insurance_option}
            onChange={(e) => setField('insurance_option', e.target.value)}
            options={INSURANCE_OPTION_OPTIONS}
          />
        </Field>
        <Field label="Indexed Strategy 1">
          <TextInput
            value={form.indexed_strategy_1}
            onChange={(e) => setField('indexed_strategy_1', e.target.value)}
          />
        </Field>
        <Field label="Indexed Strategy 2">
          <TextInput
            value={form.indexed_strategy_2}
            onChange={(e) => setField('indexed_strategy_2', e.target.value)}
          />
        </Field>
      </div>
      <Field label="Existing Policies">
        <TextArea
          rows={4}
          value={form.existing_policies}
          onChange={(e) => setField('existing_policies', e.target.value)}
          placeholder="List each policy on separate line with company, type, year issued, policy #, amount, premium"
        />
      </Field>

      <div className="rounded-lg border border-gray-200 p-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-secondary">
            Beneficiaries
          </h3>
          <button
            type="button"
            onClick={() =>
              setForm((prev) => ({
                ...prev,
                beneficiaries: [...prev.beneficiaries, { ...initialBeneficiary }],
              }))
            }
            className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
          >
            <FiPlus className="h-4 w-4" />
            Add Beneficiary
          </button>
        </div>

        <div className="space-y-4">
          {form.beneficiaries.map((entry, index) => (
            <div key={`beneficiary-${index}`} className="rounded-lg border border-gray-200 p-3">
              <div className="mb-2 flex items-center justify-between">
                <p className="text-sm font-medium text-gray-700">Beneficiary #{index + 1}</p>
                {form.beneficiaries.length > 1 && (
                  <button
                    type="button"
                    onClick={() =>
                      setForm((prev) => ({
                        ...prev,
                        beneficiaries: prev.beneficiaries.filter((_, i) => i !== index),
                      }))
                    }
                    className="inline-flex items-center gap-1 text-xs font-medium text-red-600 hover:underline"
                  >
                    <FiTrash2 className="h-3.5 w-3.5" />
                    Remove
                  </button>
                )}
              </div>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <Field label="Full Name" required>
                  <TextInput
                    value={entry.full_name}
                    onChange={(e) => updateBeneficiary(index, 'full_name', e.target.value)}
                  />
                </Field>
                <Field label="DOB" required>
                  <TextInput
                    type="date"
                    value={entry.dob}
                    onChange={(e) => updateBeneficiary(index, 'dob', e.target.value)}
                  />
                </Field>
                <Field label="SSN/ITIN (Optional)" sensitive>
                  <TextInput
                    value={entry.ssn}
                    onChange={(e) => updateBeneficiary(index, 'ssn', e.target.value)}
                  />
                </Field>
                <Field label="Relationship">
                  <TextInput
                    value={entry.relationship}
                    onChange={(e) => updateBeneficiary(index, 'relationship', e.target.value)}
                  />
                </Field>
                <Field label="Percentage">
                  <TextInput
                    value={entry.percentage}
                    onChange={(e) => updateBeneficiary(index, 'percentage', e.target.value)}
                  />
                </Field>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
